<template>
  <div class="contacts-upload-microsoft p-5">
    <b-card-group>

      <b-card :title="$t('onboarding.sync-connections.sync-microsoft.step1-title')" img-top img-src="/static/images/microsoft-uploads/on-page.svg" class="p-4">
        <i18n path="onboarding.sync-connections.sync-microsoft.step1-description" tag="p">
          <template v-slot:sign-in-cta>
            <strong>{{ $t('onboarding.sync-connections.sync-microsoft.sign-in-cta') }}</strong>
          </template>
        </i18n>
      </b-card>

      <b-card :title="$t('onboarding.sync-connections.sync-microsoft.step2-title')" img-top img-src="/static/images/microsoft-uploads/off-page.svg" class="p-4">
        <p>{{ $t('onboarding.sync-connections.sync-microsoft.step2-description') }}</p>
      </b-card>

      <b-card :title="$t('onboarding.sync-connections.sync-microsoft.step2-title')" img-top img-src="/static/images/microsoft-uploads/file-upload.svg" class="p-4">
        <p>{{ $t('onboarding.sync-connections.sync-microsoft.step2-description') }}</p>
      </b-card>

    </b-card-group>

    <div class="action-buttons">
      <b-btn class="m-0 mb-3" :href="signInWithMicrosoftURL" :disabled="!signInWithMicrosoftURL" variant="microsoft">
        {{ $t('onboarding.sync-connections.sync-microsoft.sign-in-cta') }}
      </b-btn>
    </div>

    <contacts-upload-modal ref="contactsUploadModal" network="MICROSOFT" v-bind="{ rejectedCompanyNames, rejectedDomains }"
      @finished-uploading="a => this.$emit('finished-uploading', a)"/>

  </div>
</template>

<script>
import axios from 'axios';
import qs from 'querystring';
import ContactsUploadModal from '@/modals/contacts-upload';
import validationsMixin from '@/mixins/validations';
import { formatErr } from '@/lib/utils';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    redirectUri: {
      type: String,
      default: () => null,
    },
    rejectedCompanyNames: {
      type: Array,
      default: () => [],
    },
    rejectedDomains: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [
    validationsMixin,
  ],
  components: {
    ContactsUploadModal,
  },
  mounted() {
    if (window.location.hash && window.location.hash.includes('access_token')) {
      this.onCallback(window.location.hash.substr(1));
      window.location.hash = '';
    }
  },
  computed: {
    ...mapRoot([ 'servicesOrigin' ]),
    signInWithMicrosoftURL() {
      if (this.redirectUri) {
        const scope = 'people.read';
        return `${this.servicesOrigin}/auth-redirects/microsoft?scope=${scope}&return_uri=${this.redirectUri}`;
      } else {
        return null;
      }
    },
  },
  methods: {
    async onCallback(queryHash) {
      const { contactsUploadModal } = this.$refs;
      try {
        contactsUploadModal.setState('LOADING');

        const { token_type: accessType, access_token: accessToken } = qs.parse(queryHash);

        const { data } = await axios.get('https://graph.microsoft.com/v1.0/me/people', {
          headers: {
            Authorization: `${accessType} ${accessToken}`,
          },
          params: {
            '$select': 'givenName,surname,scoredEmailAddresses',
            '$top': 1000,
          },
          validateStatus: status => status === 200,
        });

        if (!data || !Array.isArray(data.value) || !data.value.length) {
          return contactsUploadModal.setError(formatErr(new Error('No people were found'), {
            code: 'NO_PEOPLE_FOUND',
          }));
        }

        contactsUploadModal.setData({
          fields: [ 'First Name', 'Last Name', 'Email Address' ],
          data: data.value.reduce((results, { givenName, surname, scoredEmailAddresses }) => {
            const { address: emailAddress } = (scoredEmailAddresses || []).shift() || {};

            if (this.isRealEmailAddress(emailAddress)) {
              results.push({
                'First Name': givenName,
                'Last Name': surname,
                'Email Address': emailAddress,
              });
            }

            return results;
          }, []),
        });
      } catch (err) {
        contactsUploadModal.setError(err);
      }
    },
  },
};
</script>

<style lang="scss">
.contacts-upload-microsoft {
  .btn.close-x {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    color: #000;
    opacity: 0.5;
    text-shadow: 0 1px 0 #fff;
  }

  .card-group {
    .card {
      border: none;
    }

    .card-footer {
      background-color: transparent;
      border-top: none;
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn, input {
      cursor: pointer;
    }

    .btn {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts-upload/MicrosoftParser.vue